import styled from 'styled-components'

export const AppWrapperOuter = styled.div`
  display: flex;
  justify-content: center;
`

export const AppWrapperInner = styled.div`
  max-width: 400px;
  flex: 1;
  padding-bottom: 20px;
`



// WEBPACK FOOTER //
// ./src/component/_scenes/SceneManager-styled.js